/* BOLODOO floating form size guard v1: floating add-to-cart must respect the page size selectors. */
function getFloatingSizeRequirement() {
  const weddingSize = document.querySelector("[data-bnd-size]");
  if (weddingSize && !String(weddingSize.value || "").trim()) {
    return {
      message: "Please select a size before adding this item to your bag.",
      trigger: "[data-bnd-size-drawer-trigger]",
    };
  }

  /* BOLODOO shared custom measurement guard v1 */
  if (weddingSize && weddingSize.value === "Custom Size") {
    const nativeForm = document.querySelector("[data-bolodoo-native-wedding-dress]");
    if (!nativeForm || typeof nativeForm._bndCustomMeasurementsComplete !== "function" || !nativeForm._bndCustomMeasurementsComplete()) {
      return {
        message: "Please complete all custom measurements before adding this item to your bag.",
        trigger: "[data-bnd-size-drawer-trigger]",
      };
    }
  }

  const shoeSize = document.querySelector("[data-bsh-size-select]");
  if (shoeSize && !String(shoeSize.value || "").trim()) {
    return {
      message: "Please select a shoe size before adding this item to your bag.",
      trigger: "[data-bsh-open]",
    };
  }

  const flowerGirlSize = document.querySelector('[data-fgd-cart-property="size"]');
  if (flowerGirlSize && !String(flowerGirlSize.value || "").trim()) {
    return {
      message: "Please select a size before adding this dress to your bag.",
      trigger: "[data-fgd-open]",
      error: "[data-fgd-cart-error]",
    };
  }

  const womensSuitSize = document.querySelector('[data-mws-cart-property="size"]');
  if (womensSuitSize && !String(womensSuitSize.value || "").trim()) {
    return {
      message: "Please select a size before adding this suit to your bag.",
      trigger: "[data-mws-open]",
      error: "[data-mws-cart-error]",
    };
  }

  const mensJacketSize = document.querySelector('[data-mss-cart-property="jacket"]');
  const mensPantsSize = document.querySelector('[data-mss-cart-property="pants"]');
  if ((mensJacketSize && !String(mensJacketSize.value || "").trim()) || (mensPantsSize && !String(mensPantsSize.value || "").trim())) {
    return {
      message: "Please select both a jacket and pant size before adding this suit to your bag.",
      trigger: "[data-mss-open]",
      error: "[data-mss-cart-error]",
    };
  }

  return null;
}

function showFloatingSizeRequirement(form, requirement) {
  const errorWrapper = form.querySelector(".product-form__error-message-wrapper");
  const errorMessage = form.querySelector(".product-form__error-message");
  if (errorMessage) errorMessage.textContent = requirement.message;
  if (errorWrapper) errorWrapper.hidden = false;
  if (requirement.error) {
    const nativeError = document.querySelector(requirement.error);
    if (nativeError) nativeError.hidden = false;
  }
  const trigger = document.querySelector(requirement.trigger);
  if (trigger) trigger.click();
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          this.querySelector("[name=id]").disabled = false;
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        /* BOLODOO all product form size guard v1: every product-form must respect the page's size selectors. */
        const requirement = getFloatingSizeRequirement();
        if (requirement) {
          showFloatingSizeRequirement(this, requirement);
          return;
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // dispatch cart:error
              document.dispatchEvent(
                new CustomEvent("cart:error", {
                  detail: {
                    source: this.dataset.source,
                    productVariantId: formData.get("id"),
                    errors: response.description,
                    message: response.message,
                  },
                })
              );
              // dispatch cart:error
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // dispatch variant:add
            document.dispatchEvent(
              new CustomEvent("variant:add", {
                detail: {
                  variant: {
                    id: formData.get("id"),
                  },
                  quantity: Number(formData.get("quantity") || 1),
                  formElement: this.form,
                  sectionId: this.dataset.source,
                },
              })
            );
            // dispatch variant:add

            fetch(`${routes.cart_url}.js`)
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);

                // dispatch cart:change for the entire basket
                document.dispatchEvent(
                  new CustomEvent("cart:change", {
                    detail: {
                      cart: parsedState,
                      sectionId: this.dataset.source,
                    },
                  })
                );
                // dispatch cart:change for the entire basket
              })
              .catch((error) => {
                console.error("Error fetching cart state:", error);
              });

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
